import { ModalCustom } from "components/ModalCustom";
import { IDadosHistoricoVeiculo } from "../../../../interfaces/IDadosHistoricoVeiculo";
import { ModalBody, CarHeader, CarIconWrapper, PlacaText, TableWrapper, HistoricoTable, FooterWrapper, FooterButton } from "./style";
import { FaCar } from "react-icons/fa";
import { converterDataHoraBr } from "_utils/Data";
import { StatusItemLoteBloqueio } from "../StatusItemLoteBloqueio";
import { IconeErro } from "../iconeErro";

interface IProps {
  show: boolean;
  handleClose: () => void;
  historicoVeiculo: IDadosHistoricoVeiculo[];
  placa: string;
}

export function ModalHistoricoVeiculo({
  show,
  handleClose,
  historicoVeiculo,
  placa,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Histórico do veículo"
      centered
      footer
      size="lg"
      footerTools={
        <FooterWrapper>
          <FooterButton onClick={handleClose} outline variante="primary">
            Fechar
          </FooterButton>
        </FooterWrapper>
      }
    >
      <ModalBody>
        <CarHeader>
          <CarIconWrapper>
            <FaCar size={20} color="#dc3545" />
          </CarIconWrapper>
          <PlacaText>{placa}</PlacaText>
        </CarHeader>
        <TableWrapper>
          <HistoricoTable>
            <thead>
              <tr>
                <th>Data</th>
                <th>ID Processo</th>
                <th>Ação</th>
                <th>Usuário</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {historicoVeiculo.map((item, index) => (
                <tr key={index}>
                  <td>{item.dataCriacao ? converterDataHoraBr(item.dataCriacao) : "-"}</td>
                  <td>{item.idProcesso ?? "-"}</td>
                  <td>{item.acao === "bloquear" ? "Bloqueio" : item.acao === "desbloquear" ? "Desbloqueio" : item.acao ?? "-"}</td>
                  <td>{item.nomeUsuario ?? "-"}</td>
                  <td>
                    {item.status ? (
                      <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <StatusItemLoteBloqueio status={item.status as "PROCESSANDO" | "ERRO" | "CONCLUIDO"} />
                        {item.status === "ERRO" && item.observacao && (
                          <IconeErro
                            observacao={item.observacao}
                            dataSolicitacao={item.dataCriacao}
                            acao={item.acao}
                          />
                        )}
                      </span>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </HistoricoTable>
        </TableWrapper>
      </ModalBody>
    </ModalCustom>
  );
}
